const HKMarketList = ['176', '177', '178', '179', '180', '181', '182', '183'];

export function translateStock(stock, market) {
  const num_4 = 4;
  if (stock.indexOf('.') !== -1) {
    const [code, short] = stock.toLocaleUpperCase().split('.');
    if (short === 'HK') {
      const res = code.length > num_4 ? code.slice(-num_4) : code;
      return `${res}.${short}`;
    }
    return stock;
  } else if (HKMarketList.includes(market)) {
    const resCode = stock.length > num_4 ? stock.slice(-num_4) : stock;
    return `HK${resCode}`;
  } else {
    return stock;
  }
}

export const generateRandomCode = function (bit) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < bit; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
